import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { TokenStorageService } from './token-storage.service';
import { RefreshTokenRequest } from '../auth/auth.type';
import { AuthService } from '../auth/auth.service';
import { MatDialog } from '@angular/material/dialog';


const INACTIVITY_ALLOWED_TIME_BEFORE_NOTICE = 29 // in minutes

@Injectable()
export class UserActivityService {

    /**
     * to avoid continues mouse events detection while renewing session
     */
    private _isLocked: boolean = false

    private _timeCounterInMinutes: number = 0

    constructor(
        private _authService: AuthService,
        private _dialog: MatDialog,
        private _tokenService: TokenService,
        private _tokenStorageService: TokenStorageService
    ) {
        
        setInterval(() => { 

            // if logged in
            if(!this._tokenService.checkRefreshTokenExpiration()) {
                this._timeCounterInMinutes++
            }
            
            if(this._timeCounterInMinutes === INACTIVITY_ALLOWED_TIME_BEFORE_NOTICE) {

                // const userInactiviyDialog = this._dialog.open<UserInactivityDialogComponent, UserInactivityDialogComponentData>(UserInactivityDialogComponent, {
                //     data: {
                //       countDown: 60
                //     },
                //     minWidth: 600,
                //     panelClass: 'custom-mat-dialog-container'
                // });

                // userInactiviyDialog.afterClosed().subscribe((event: 'conitnue-working' | 'logout' | undefined) => {

                //     this._timeCounterInMinutes = 0

                //     if(event === undefined) {
                //         return
                //     }

                //     event === 'logout' ? this._tokenService.logout() : this._refreshTokenUpdate()
                // })
            }
        }, 60000);
    }

    initListeners() {
        window.addEventListener('mousemove',        () => this._check());
        window.addEventListener('click',            () => this._check());
        window.addEventListener('keypress',         () => this._check());
        window.addEventListener('DOMMouseScroll',   () => this._check());
        window.addEventListener('mousewheel',       () => this._check());
        window.addEventListener('touchmove',        () => this._check());
        window.addEventListener('MSPointerMove',    () => this._check());
    }

    /**
     * Checks whether the access token is expired
     * gets new set of tokens if access token is expired and refresh token is not
     * @returns 
     */
    private _check() {

        // if dialog is open ignore any event detection
        if(this._timeCounterInMinutes === INACTIVITY_ALLOWED_TIME_BEFORE_NOTICE) {
            return
        }

        const _isAccessTokenExpired: boolean | null = this._tokenService.checkTokenExpiration();
        const _isRefreshTokenExpired: boolean = this._tokenService.checkRefreshTokenExpiration();

        // before logging in
        if(_isAccessTokenExpired === null || _isRefreshTokenExpired) {
            return
        }

        // if access token not expired, ignore...
        if(!_isAccessTokenExpired) {
            return
        }

        // if access token needs to be refreshed and not in locked stayed
        if((_isAccessTokenExpired && !_isRefreshTokenExpired) && !this._isLocked) {
            this._refreshTokenUpdate()
        }
    }

    /**
     * 
     */
    private _refreshTokenUpdate() {

        // lock the refresh token call until the current one is complete
        this._isLocked = true

        const accessToken: any = this._tokenStorageService.getAccessToken()
        const refreshToken: any = this._tokenStorageService.getRefreshToken()

        const refreshTokenRequest: RefreshTokenRequest = {
            preToken: accessToken,
            refreshToken: refreshToken
        }
        // refresh access token
        this._authService.refreshTokenLocalStorageUpdate(refreshTokenRequest).then(() => {
            this._isLocked = false
            this._timeCounterInMinutes = 0
        })
    }
}